import { render, staticRenderFns } from "./PedestalInstallationOrder.vue?vue&type=template&id=0024e828&"
import script from "./PedestalInstallationOrder.vue?vue&type=script&lang=js&"
export * from "./PedestalInstallationOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports